export default function scrollerSponsors(widgetNameVariable, widgetOptsVariable) {
  const widgetName = widgetNameVariable;
  const widgetOpts = widgetOptsVariable;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        if (widgetName === 'fiber-scroller-sponsors') {
          updateFirstSponsorsStructure();
        } else {
          updateSecondSponsorsStructure();
        }

        const pauseBtn = $(`#${widgetName} .sponsor-controls-container button`);
        pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
        $(`#${widgetName} .sponsor-playpause-btn`).on('click', function () {
          $(`#${widgetName} .sponsorWidgetContainer `).toggleClass('sponsors-paused');
        });
      }, 2000);

      clearInterval(interval);
    }
  }, 800);

  function updateFirstSponsorsStructure() {
    $(`#${widgetName} .sponsorWidgetContainer`).appendTo('.fiber-scroller-container');
    $(`#${widgetName} .sponsorCarouselImageContainer`).addClass('fiber-container');
    $(`#${widgetName} #sponsorArrowLeft`).appendTo('.fiber-scroller-container');
    $(`#${widgetName} #sponsorArrowRight`).appendTo('.fiber-scroller-container');
  }

  function updateSecondSponsorsStructure() {
    $(`#${widgetName} .sponsorWidgetContainer`).appendTo('.second-scroller-container');
    $(`#${widgetName} .sponsorCarouselImageContainer`).addClass('scroller-wrapper');
  }

  return saffire.widgets.sponsors($widget, {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 5,
    bw: false,
    rotate: true,
  });
}
